import { Helmet } from "react-helmet-async";
import { FaFacebookF, FaInstagram, FaTiktok, FaPhoneAlt } from "react-icons/fa";
import { HashLink } from "react-router-hash-link";

const OFFSET = 70;

const scrollWithOffset = (el) => {
  const y = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;
  window.scrollTo({ top: y, behavior: "smooth" });
};

const Footer = () => {
  const anchors = [
    { to: "meista", label: "Meistä" },
    { to: "ohjelmisto", label: "Ohjelmisto" },
    { to: "esiintymiset", label: "Esiintymiset" },
    { to: "media", label: "Media" },
    { to: "useinkysyttya", label: "UKK" }
  ];

  return (
    <footer
      role="contentinfo"
      className="
        bg-white dark:bg-joyrideBars
        text-joyrideNavy dark:text-joyrideCyan
        py-12
        relative
        dark:shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.5)]
      "
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MusicGroup",
            name: "Bilebändi Joyride",
            url: "https://bilebandijoyride.com",
            logo: "https://bilebandijoyride.com/static/media/instagram_versio.png",
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+358443519265",
                contactType: "booking",
                email: "info@bilebandijoyride.com",
                areaServed: "FI",
                availableLanguage: ["fi", "en"]
              }
            ],
            sameAs: [
              "https://www.facebook.com/bilebandijoyride",
              "https://www.instagram.com/bilebandijoyride/",
              "https://www.tiktok.com/@bilebandijoyride"
            ]
          })}
        </script>
      </Helmet>

      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Yhteystiedot */}
        <address className="not-italic">
          <h3 className="text-2xl text-joyridePurple dark:text-joyrideCyan font-lobster font-semibold mb-2 dark:text-shadow-lg">
            Yhteystiedot
          </h3>
          <p className="flex justify-center md:justify-start items-center gap-2 dark:text-shadow-sm">
            <a href="mailto:kontakti@bilebandijoyride.com" className="hover:underline focus:underline">
              kontakti@bilebandijoyride.com
            </a>
          </p>
          <p className="flex justify-center md:justify-start items-center gap-2 dark:text-shadow-sm">
            <FaPhoneAlt aria-hidden="true" />
            <a href="tel:+358443519265" className="hover:underline focus:underline">
              +358 44 351 9265
            </a>
          </p>
          <p className="mt-2 text-sm dark:text-shadow-sm">
            Buukkaukset hoitaa:<br />
            <a
              href="https://spiderlegsproductions.com/esiintyja/bilebandijoyride"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-joyrideCyan dark:hover:text-joyrideLight transition"
            >
              Spiderlegs Productions
            </a>
          </p>
        </address>

        {/* Navigaatio */}
        <nav aria-label="Sivuston sisäinen navigaatio">
          <h3 className="text-2xl font-semibold mb-2 dark:text-shadow-lg text-joyridePurple dark:text-joyrideCyan font-lobster">
            Navigointi
          </h3>
          <ul className="flex flex-col items-center md:items-start space-y-1">
            {anchors.map(({ to, label }) => (
              <li key={to}>
                <HashLink
                  to={`/#${to}`}
                  scroll={scrollWithOffset}
                  className="cursor-pointer hover:text-joyrideCyan dark:hover:text-joyrideLight transition dark:text-shadow-sm"
                >
                  {label}
                </HashLink>
              </li>
            ))}
            <li>
              <HashLink
                to="/privacy#top"
                scroll={scrollWithOffset}
                className="cursor-pointer hover:text-joyrideCyan dark:hover:text-joyrideLight transition dark:text-shadow-sm"
              >
                Tietosuoja
              </HashLink>
            </li>
          </ul>
        </nav>

        {/* Somelinkit */}
        <div className="flex flex-col items-center md:items-end">
          <h3 className="text-2xl font-semibold mb-2 dark:text-shadow-lg text-joyridePurple dark:text-joyrideCyan font-lobster">
            Seuraa meitä
          </h3>
          <div className="flex justify-center md:justify-end space-x-4 text-2xl">
            <a
              href="https://www.facebook.com/bilebandijoyride"
              target="_blank"
              rel="me noopener noreferrer"
              aria-label="Facebook"
              className="hover:text-joyrideCyan transition shadow-2xl dark:shadow-2xl"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/bilebandijoyride/"
              target="_blank"
              rel="me noopener noreferrer"
              aria-label="Instagram"
              className="hover:text-joyrideCyan transition shadow-2xl dark:shadow-2xl"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@bilebandijoyride"
              target="_blank"
              rel="me noopener noreferrer"
              aria-label="TikTok"
              className="hover:text-joyrideCyan transition shadow-2xl dark:shadow-2xl"
            >
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>

      {/* Alatunniste */}
      <div className="mt-8 border-t border-joyrideNavy pt-4 text-center text-sm dark:text-shadow-sm">
        © {new Date().getFullYear()} Bilebändi Joyride – Sivuston toteutus{" "}
        <a
          href="https://arttustenius.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-joyrideCyan dark:hover:text-joyrideLight transition"
        >
          Arttu Stenius
        </a>
      </div>
    </footer>
  );
};

export default Footer;
